import { render, staticRenderFns } from "./refund_list.vue?vue&type=template&id=16810cab"
import script from "./refund_list.vue?vue&type=script&lang=js"
export * from "./refund_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports